import { useMemo } from 'react';
import { useHistory } from '../use-history';
import { getQueryParams } from '../../utils/query-param-helpers';

/**
 * Returns the current value of a query param from the URL.
 * Re-computes only when `history.location.search` changes.
 */
export function useQueryParamValue(
  key: string,
  defaultValue: string = ''
): string {
  const history = useHistory();

  return useMemo(() => {
    const query = getQueryParams(history);
    return (query[key] as string) ?? defaultValue;
  }, [defaultValue, history.location.search, key, history]);
}
